var _style, _g, _path, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 106 40",
    style: {
      enableBackground: "new 0 0 106 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4B4B4B;}\r\n\t.st1{fill:#6FDA44;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.8,6.9c-4.4,0-8,3.6-8,8.1s3.6,8.1,8,8.1s8-3.6,8-8.1S69.2,6.9,64.8,6.9z M64.8,19.8 c-2.6,0-4.7-2.1-4.7-4.7s2.1-4.7,4.7-4.7s4.7,2.1,4.7,4.7C69.5,17.6,67.3,19.8,64.8,19.8z M82.6,10.8c-2.3,0-4.1,1.9-4.1,4.2v7.7 H75V7.4h3.5v2.4c0,0,1.5-2.4,4.5-2.4h1v3.4L82.6,10.8L82.6,10.8z M47.7,7.4l2.6,10.5l2.8-10.5h3.5l-4.4,15.3h-3.4L46.1,12 l-2.7,10.7H40L35.5,7.4h3.4l3,10.5l2.5-10.5H47.7z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.2,14.4c2.4-1.4,4.1-4,4.1-7h-3.5c0,2.6-2.1,4.7-4.6,4.7h-0.5V0h-3.5v22.7h3.5v-7.2h0.4 c0.4,0,0.8,0.2,0.9,0.5l4.9,6.7h4.1L94.2,14.4L94.2,14.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.4,6.9c-3.8,0-6.7,2.5-7.8,6.5c-1.8-2.8-3.2-6-4-8.7h-4v10.6c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8 V4.7H0v10.6c0,4.4,3.5,7.9,7.8,7.9c4.3,0,7.8-3.5,7.8-7.9v-1.8c0.8,1.6,1.8,3.3,2.9,4.8L16,30h4.1l1.8-8.5c1.6,1,3.4,1.6,5.5,1.6 c4.4,0,8-3.6,8-8.2C35.4,10.5,31.8,6.9,27.4,6.9z M27.4,19c-1.6,0-3.2-0.7-4.5-1.8l0.4-1.6v-0.1c0.3-1.7,1.2-4.6,4.2-4.6 c2.2,0,4,1.8,4,4C31.4,17.2,29.5,19,27.4,19z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.5,7.9h-1.1V7.5h2.7v0.4H101V11h-0.4V7.9H100.5z M102.8,7.5h0.4l1.2,1.9l1.2-1.9h0.4v3.4h-0.4V8.1 l-1.2,1.8l-1.2-1.8v2.8h-0.4V7.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwork);
export default __webpack_public_path__ + "static/media/upwork.94b0372512e723df6fabb323064f433a.svg";
export { ForwardRef as ReactComponent };